/* 🤖 this file was generated by svg-to-ts */
export const matIconCloseFullscreen: {
  name: 'close-fullscreen';
  data: string;
} = {
  name: 'close-fullscreen',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 3.41 16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"/></svg>`
};
